<template>
    <div class="thanks-product">
        <a
            :href="result.detailPage"
            class="thanks-product__picture"
        >
            <DefImg :result="result.picture" />
        </a>

        <div class="thanks-product__properties">
            <a
                :href="result.detailPage"
                class="thanks-product__name"
            >
                {{ result.name }}
            </a>
            <a
                v-if="result.collection"
                :href="result.collection.detailPage"
                class="thanks-product__collection"
            >
                {{ result.collection.name }}
            </a>
<!--            <p class="thanks-product__art">-->
<!--                арт. {{ result.article }}-->
<!--            </p>-->
            <p
                v-if="getSizes && getActiveSize"
                class="thanks-product__size"
            >
                <span>
                    {{ messages.size }}
                </span>: {{ getActiveSize.value }}
            </p>
        </div>
        <div class="thanks-product__prices">
            <DefPriceOld v-if="result.price.printPriceOld">
                {{ result.price.printPriceOld }}
            </DefPriceOld>
            <DefPrice v-if="result.price.printPrice ">
                {{ result.price.printPrice }}
            </DefPrice>
            <DefSale v-if="result.price?.discountPercent > 0">
                {{ result.price.printDiscountPercent }}
            </DefSale>
            <DefSale v-else-if="result.price?.discount > 0">
                {{ messages.paymentData.discountPriceForProduct + ' ' + result.price.printDiscount }}
            </DefSale>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import DefImg from "../../def/DefImg/DefImg";
import DefPriceOld from "../../def/DefPriceOld/DefPriceOld";
import DefPrice from "../../def/DefPrice/DefPrice";
import DefSale from "../../def/DefSale/DefSale";
import DefProgramMe from "../../def/DefProgramMe/DefProgramMe";

export default {
    name: 'ThanksProduct',
    props: ['result', 'messages'],
    components: {
        DefImg,
        DefPrice,
        DefPriceOld,
        DefSale,
        DefProgramMe,
    },
    computed: {
        ...mapState({
            messages: ({ checkout }) => checkout?.data?.vue?.messages,
        }),
        getSizes() {
            return this.result?.propsForCheck?.SIZES;
        },
        getActiveSize() {
            return this.getSizes?.find(el => el.active);
        },
    }
}
</script>

<style lang="scss" scoped>
.thanks-product{
    display: grid;
    grid-template-columns: 64px repeat(2, 1fr);
    grid-column-gap: 8px;
    padding: 8px 0 12px;
    align-items: center;
    @include point-md{
        grid-template-columns: 88px repeat(2, 1fr);
        grid-column-gap: 16px;
    }
    @include point-lg{
        grid-template-columns: 80px repeat(2, 1fr);
    }
    &__prices,
    &__properties{
        display: flex;
        flex-direction: column;
    }
    &__prices{
        display: grid;
        grid-row-gap: 4px;
        text-align: end;
    }
    &__name{
        font-weight: 500;
        font-size: 14px;
        line-height: 115%;
        letter-spacing: 0.08em;
        text-transform: uppercase;
        margin-bottom: 2px;
        @include point-md{
            font-size: 16px;
        }
        @include point-lg{
            font-size: 14px;
        }
    }
    &__collection{
        font-size: rem(10);
        line-height: 100%;
        letter-spacing: 0.08em;
        text-transform: uppercase;
        color: var(--color-dark-grey);
        margin-bottom: 12px;
    }
    //&__art{
    //    font-size: 11px;
    //    line-height: 110%;
    //    color: var(--color-dark-grey);
    //    margin-bottom: 8px;
    //}
    &__size{
        font-weight: 400;
        font-size: 14px;
        line-height: 100%;
        color: #757575;
    }
    :deep(.def-price-old-component) {
        font-size: 12px;
    }
    :deep(.def-sale){
        margin-top: 2px;
    }
    :deep(.def-price-component){
        font-size: 14px;
    }
}
</style>